// extracted by mini-css-extract-plugin
export default {"btn":"globalStyles_btn__V2fGQ","navbar":"globalStyles_navbar__ebJr1"};